import { CompanyPage } from "@pages/CompanyPage/CompanyPage";

function CompanyMasterListPage() {
  return <CompanyPage />;
}

export { CompanyMasterListPage };
